import swaggerLogin from '../Swagger/login'
import { push } from 'react-router-redux'
import { store } from 'store/createStore'
import { displayErrorMsg } from 'routes/Login/modules/login'
import 'whatwg-fetch'

export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const LOG_OUT = 'LOG_OUT'
export const CLEAR_STATE = 'CLEAR_STATE'
export const STORE_ROUTE = 'STORE_ROUTE'
export const STORE_TOKEN = 'STORE_TOKEN'
export const CLEAR_ROUTE = 'CLEAR_ROUTE'

const LOGIN_ERROR_MESSAGE = 'Login error, try again'

export function requestLogin (creds) {
  return {
    type: LOGIN_REQUEST,
    creds
  }
}

export function receiveLogin (idToken) {
  return {
    type: LOGIN_SUCCESS,
    id_token: idToken
  }
}

export function loginError (message) {
  return {
    type: LOGIN_FAILURE,
    message
  }
}

export function storeToken (token) {
  return {
    type: STORE_TOKEN,
    payload: token
  }
}

export function storeRoute (route) {
  return {
    type: STORE_ROUTE,
    payload: route
  }
}

export function clearRoute () {
  return {
    type: CLEAR_ROUTE
  }
}

export function getToken () {
  return store.getState().auth.token
}

export const loginUser = (creds) => {
  return (dispatch, getState) => {
    const nextRoute = getState().auth.nextRoute
    dispatch(clearState())
    dispatch(storeNextRoute(nextRoute))
    dispatch(requestLogin())
    return swaggerLogin(creds)
    .then(data => {
      dispatch(storeToken(creds))
      dispatch(receiveLogin(creds))
    })
    .then(() => dispatch(push('/')))
    .catch(err => {
      dispatch(loginError(err))
      dispatch(displayErrorMsg(LOGIN_ERROR_MESSAGE))
    })
  }
}

export function logOut () {
  return {
    type: LOG_OUT
  }
}

export const loggingOut = () => {
  const nextRoute = (store.getState().router.locationBeforeTransitions || {}).pathname || '/'
  store.dispatch(logOut())
  store.dispatch(clearState())
  store.dispatch(storeNextRoute(nextRoute))
  store.dispatch(push('/login'))
}

export const logOutUser = () => {
  return (dispatch, getState) => {
    const nextRoute = (getState().router.locationBeforeTransitions || {}).pathname || '/'
    dispatch(logOut())
    dispatch(clearState())
    dispatch(storeNextRoute(nextRoute))
    dispatch(push('/login'))
  }
}

export const addStorageListener = () => {
  return (dispatch, getState) => {
    return window.addEventListener('storage', (e) => {
      const authToken = localStorage.getItem('id_token')
      if (!authToken || authToken.length < 1) {
        dispatch(clearState())
        dispatch(push('/login'))
      }
    })
  }
}

export function clearState () {
  return {
    type: CLEAR_STATE
  }
}

export const validateToken = async token => {
  let headers = new Headers()
  let init = {
    method: 'GET',
    headers: headers,
    mode: 'cors',
    cache: 'default'
  }
  var request = new Request('https://www.googleapis.com/oauth2/v3/tokeninfo?id_token=' + token, init)
  const response = await fetch(request).then(resp => resp.status === 200)
  return response
}

export const validateUser = (token) => {
  return (dispatch, getState) => {
    validateToken(token).then(valid => { if (!valid) { dispatch(logOutUser()) } })
  }
}

export const storeNextRoute = (route) => {
  return (dispatch, getState) => {
    if (route !== '/login') {
      dispatch(storeRoute(route))
    }
  }
}

export const clearStoredRoute = (token) => {
  return (dispatch, getState) => {
    dispatch(clearRoute())
  }
}

const ACTION_HANDLERS = {
  [LOGIN_SUCCESS]: (state, action) => {
    return ({...state, isAuthenticated: true, fetching: false})
  },
  [LOG_OUT]: (state, action) => {
    return ({...state, isAuthenticated: false, fetching: false})
  },
  [LOGIN_REQUEST]: (state, action) => {
    return ({...state, fetching: true})
  },
  [LOGIN_FAILURE]: (state, action) => {
    return ({...state, fetching: false})
  },
  [STORE_ROUTE]: (state, action) => {
    return ({...state, nextRoute: action.payload})
  },
  [STORE_TOKEN]: (state, action) => {
    return ({...state, token: action.payload})
  },
  [CLEAR_ROUTE]: (state, action) => {
    return ({...state, nextRoute: undefined})
  }
}

const initialState = {
  isAuthenticated: false,
  fetching: false
}

export default function authReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/components/Auth/index.js